.benefits {
  padding: 0 0;
}

.title {
  color: #231e19;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  margin-bottom: 20px;
}

.itemWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 17px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  img {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }

  p {
    color: #231e19;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .title,
    .item p {
      color: #fffbf2;
    }
  }
}
